import { useEffect, useReducer } from "react";

/** 83 -> "1:23" */
export const formatClock = (totalSeconds) => {
  const seconds = Math.max(0, totalSeconds);
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}`;
};

/**
 * Whole seconds left until `deadline` (epoch ms); 0 when there is none or it has passed.
 * The value is derived from the clock on every render, so a freshly set deadline never
 * flashes a stale number; the interval only schedules re-renders and stops at zero.
 */
export default function useCountdown(deadline) {
  const [, tick] = useReducer((count) => count + 1, 0);

  useEffect(() => {
    if (!deadline || deadline <= Date.now()) return undefined;
    const timer = setInterval(() => {
      tick();
      if (Date.now() >= deadline) clearInterval(timer);
    }, 250);
    return () => clearInterval(timer);
  }, [deadline]);

  return deadline ? Math.max(0, Math.ceil((deadline - Date.now()) / 1000)) : 0;
}
